// src/pages/AboutPage.tsx
import React from 'react';

const AboutPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 text-gray-900 dark:text-gray-100 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold mb-8 text-center">About Word Game</h1>
        
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-6 mb-8">
          <h2 className="text-2xl font-semibold mb-4">How to Play</h2>
          <p className="mb-4">
            Word Game is a fun and challenging word memory game that tests your memory and vocabulary skills.
            The game presents you with words to remember and type correctly to score points.
          </p>
          
          <h3 className="text-xl font-semibold mt-6 mb-3">Game Modes</h3>
          <ul className="list-disc pl-6 space-y-2 mb-6">
            <li><span className="font-medium">Classic Mode:</span> Play with random words of varying lengths.</li>
            <li><span className="font-medium">Daily Challenge:</span> A new set of words every day for all players.</li>
          </ul>

          <h3 className="text-xl font-semibold mt-6 mb-3">Scoring</h3>
          <ul className="list-disc pl-6 space-y-2">
            <li>Earn points for each correct word</li>
            <li>Bonus points for faster completion</li>
            <li>Build streaks by getting all words correct in a round</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;